var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-page404"},[_c('h1',[_vm._v("404 page not found")]),_c('router-link',{staticClass:"btn btn-primary btn-box",attrs:{"to":"/"}},[_vm._v(" Back to your library ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }